import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Interfaccia per i dati dell'agente
interface Agent {
  img: string;
  name: string;
  tel: string;
  mobile: string;
  email: string;
}

// Funzione hook per recuperare gli agenti per agenzia
export const useGetAgentsByAgency = (agencyId: number) => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        console.log("Richiesta in corso...");  // Log di avvio richiesta
        console.log("Con l'agencyId", agencyId)

        const response = await axios.post(`${API_BASE_URL}/agents`, {
          agencyId,
          limit: 10,
          offset: 0,
          withCount: false,
        });

        console.log("Risposta ricevuta:", response.data);  // Log della risposta ricevuta

        // Mappiamo la risposta
        const agentData = response.data.map((agent: any) => ({
          img: agent.img || "/assets/images/placeholder_agent.jpg",  // Puoi sostituire con l'URL dell'immagine dell'agente, se disponibile
          name: agent.name + " " + agent.lastName,
          tel: agent.phone1,
          mobile: agent.phone2 || "",  // Se non c'è phone2, lascia vuoto
          email: agent.email || "",  // Assicurati che email non sia null
        }));

        console.log("Dati mappati:", agentData);  // Log dei dati mappati

        setAgents(agentData);
      } catch (err) {
        console.error("Errore nel recupero degli agenti:", err);
        setError("Errore nel recupero degli agenti");
      } finally {
        setLoading(false);
      }
    };

    fetchAgents();
  }, [agencyId]);

  return { agents, loading, error };
};